import { Instrument, Share } from '../domain/entities/OrdersEntity'
import { cn } from '@/utils/cn'

export const InstrumentDetail = ({ instrument, className }: { instrument: Instrument | Share, className?: string }) => {

    const isInstrument = (instrument: Instrument | Share): instrument is Instrument => {
        return "issuanceDate" in instrument && "maturityDate" in instrument;
    }

    return (
        <div
            className={cn(
                "bg-[--secondary-200] text-card-foreground rounded-lg border border-[--secondary-300] shadow-sm",
                "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 p-4",
                "dark:border-[--secondary-600] dark:bg-[--secondary-700]",
                className,
            )}
        >
            <div className="space-y-1">
                <h4 className="text-sm leading-none text-sm font-medium">ISIN</h4>
                <p className="text-muted-foreground text-xs">
                    {instrument.isin}
                </p>
            </div>
            <div className="space-y-1">
                <h4 className="text-sm leading-none text-sm font-medium">Emisor</h4>
                <p className="text-muted-foreground text-xs">
                    {instrument.issuerName}
                </p>
            </div>
            {isInstrument(instrument) && (
                <>
                    <div className="space-y-1">
                        <h4 className="text-sm font-medium">Fecha emisión</h4>
                        <p className="text-muted-foreground text-xs">{instrument.issuanceDate}</p>
                    </div>
                    <div className="space-y-1">
                        <h4 className="text-sm font-medium">Fecha vencimiento</h4>
                        <p className="text-muted-foreground text-xs">{instrument.maturityDate}</p>
                    </div>
                    <div className="space-y-1">
                        <h4 className="text-sm font-medium">Tasa facial</h4>
                        <p className="text-muted-foreground text-xs">{instrument.interestRate}</p>
                    </div>
                    <div className="space-y-1">
                        <h4 className="text-sm font-medium">Periodicidad</h4>
                        <p className="text-muted-foreground text-xs">{instrument.frequency}</p>
                    </div>
                    <div className="space-y-1">
                        <h4 className="text-sm font-medium">Moneda</h4>
                        <p className="text-muted-foreground text-xs">{instrument.currency}</p>
                    </div>
                    <div className="space-y-1">
                        <h4 className="text-sm font-medium">Calificación</h4>
                        <p className="text-muted-foreground text-xs">{instrument.rating}</p>
                    </div>
                </>
            )}
        </div>
    )
}
